import React, { useState } from "react";
import IconButton from "@mui/material/IconButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import Tooltip from "@mui/material/Tooltip";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import BorderColorIcon from "@mui/icons-material/BorderColor";
import DeleteIcon from "@mui/icons-material/Delete";
import WhereToVoteTwoToneIcon from "@mui/icons-material/WhereToVoteTwoTone";
import ReceiptLongIcon from "@mui/icons-material/ReceiptLong";
import PendingActionsIcon from "@mui/icons-material/PendingActions";
import AssignmentTurnedInIcon from "@mui/icons-material/AssignmentTurnedIn";
import QueryStatsIcon from "@mui/icons-material/QueryStats";
import ForumIcon from "@mui/icons-material/Forum";
import { ESTADOS_CON_ERROR_FACTURACION, ESTADOS_FACTURADOS } from "./constantes";

const MOTIVO_SECTOR = "Disponible solo para usuarios de granel (sector 12)";
const MOTIVO_COMERCIAL = "No disponible para comerciales";

// Acciones posibles, en el orden del menú de la V1. Mismas reglas de estado y permisos que la V1.
const ACCIONES = [
  {
    id: "editar",
    titulo: "Editar",
    icono: <BorderColorIcon color="primary" />,
    aplica: (p) => p.id_estado === 19 || p.id_estado === 21,
    bloqueo: (permisos) => (!permisos.esGranel ? MOTIVO_SECTOR : null),
  },
  {
    id: "cancelar",
    titulo: "Cancelar pedido",
    icono: <DeleteIcon color="error" />,
    aplica: (p) => [19, 21, 23].includes(p.id_estado),
    bloqueo: (permisos) => (!permisos.esGranel ? MOTIVO_SECTOR : null),
  },
  {
    id: "visita",
    titulo: "Registrar visita",
    icono: <WhereToVoteTwoToneIcon color="success" />,
    aplica: (p) => p.id_estado === 23,
    bloqueo: (permisos) => (!permisos.esGranel ? MOTIVO_SECTOR : null),
  },
  {
    id: "verFactura",
    titulo: "Ver factura",
    icono: <ReceiptLongIcon color="primary" />,
    aplica: (p) => ESTADOS_FACTURADOS.includes(p.id_estado),
  },
  {
    id: "marcarAprobado",
    titulo: "Marcar aprobado",
    icono: <PendingActionsIcon color="warning" />,
    aplica: (p) => p.id_estado === 41 || p.id_estado === 32,
    bloqueo: (permisos) => (!permisos.esGranel ? MOTIVO_SECTOR : null),
  },
  {
    id: "facturar",
    titulo: "Facturar",
    icono: <AssignmentTurnedInIcon sx={{ color: "#BB8FCE" }} />,
    aplica: (p) => [40, 243, 244].includes(p.id_estado),
    bloqueo: (permisos) => (permisos.esComercial ? MOTIVO_COMERCIAL : null),
  },
  {
    id: "verError",
    titulo: "Ver error",
    icono: <QueryStatsIcon color="error" />,
    aplica: (p) => ESTADOS_CON_ERROR_FACTURACION.includes(p.id_estado),
  },
  {
    // Como en la V1: solo pedidos pendientes con gestiones
    id: "gestionesCC",
    titulo: "Gestiones de cuenta corriente",
    icono: <ForumIcon color="info" />,
    aplica: (p) => p.id_estado === 19 && p.g_cc_observaciones > 0,
  },
];

export const accionesDelPedido = (pedido, permisos) =>
  ACCIONES.filter((a) => a.aplica(pedido)).map((a) => ({
    ...a,
    motivoBloqueo: a.bloqueo ? a.bloqueo(permisos) : null,
  }));

// Menú de tres puntos con las acciones del pedido. onAccion(idAccion, pedido)
function AccionesPedido({ pedido, permisos, onAccion }) {
  const [ancla, setAncla] = useState(null);
  const acciones = accionesDelPedido(pedido, permisos);
  if (!acciones.length) return null;

  const ejecutar = (accion) => {
    setAncla(null);
    if (!accion.motivoBloqueo) onAccion(accion.id, pedido);
  };

  return (
    <>
      <IconButton size="small" onClick={(e) => setAncla(e.currentTarget)}>
        <MoreVertIcon />
      </IconButton>
      <Menu anchorEl={ancla} open={!!ancla} onClose={() => setAncla(null)}>
        {acciones.map((accion) => (
          <Tooltip key={accion.id} title={accion.motivoBloqueo || ""} placement="left" arrow>
            {/* span: el tooltip necesita un elemento habilitado para mostrarse */}
            <span>
              <MenuItem disabled={!!accion.motivoBloqueo} onClick={() => ejecutar(accion)}>
                <ListItemIcon>{accion.icono}</ListItemIcon>
                <ListItemText>{accion.titulo}</ListItemText>
              </MenuItem>
            </span>
          </Tooltip>
        ))}
      </Menu>
    </>
  );
}

export default AccionesPedido;
